module.exports = __webpack_public_path__ + "static/media/2025_NEW_Lumina.81f6254a.pdf";